import React, { createContext, useContext, useState, useCallback } from "react";

const EvaluationsContext = createContext(null);

const sampleEvaluations = [
  {
    id: "ev-sample-1",
    sectorId: "raw-nut-receiving",
    sectorName: "Raw Nut Receiving",
    operatorId: "w-5",
    operatorName: "John Doe",
    supervisorId: "w-1",
    kpiScores: { "kpi-1": 4, "kpi-2": 5, "kpi-3": 3, "kpi-4": 4, "kpi-5": 5 },
    kpiNotes: { "kpi-1": "Within range.", "kpi-5": "Full PPE compliance." },
    date: "2025-01-27T14:30:00.000Z",
  },
  {
    id: "ev-sample-2",
    sectorId: "raw-nut-receiving",
    sectorName: "Raw Nut Receiving",
    operatorId: "w-6",
    operatorName: "Ama Osei",
    supervisorId: "w-1",
    kpiScores: { "kpi-1": 5, "kpi-2": 4, "kpi-3": 4, "kpi-4": 5, "kpi-5": 4 },
    kpiNotes: {},
    date: "2025-01-27T11:00:00.000Z",
  },
  {
    id: "ev-sample-3",
    sectorId: "raw-nut-receiving",
    sectorName: "Raw Nut Receiving",
    operatorId: "w-7",
    operatorName: "Kofi Addo",
    supervisorId: "w-1",
    kpiScores: { "kpi-1": 3, "kpi-2": 3, "kpi-3": 4, "kpi-4": 4, "kpi-5": 5 },
    kpiNotes: { "kpi-1": "Slightly high moisture on batch 2." },
    date: "2025-01-26T16:45:00.000Z",
  },
  {
    id: "ev-sample-4",
    sectorId: "steam-roasting",
    sectorName: "Steam Roasting",
    operatorId: "w-8",
    operatorName: "Abena Boateng",
    supervisorId: "w-2",
    kpiScores: { "kpi-1": 4, "kpi-2": 5, "kpi-3": 5, "kpi-4": 4, "kpi-5": 4 },
    kpiNotes: {},
    date: "2025-01-27T09:15:00.000Z",
  },
  {
    id: "ev-sample-5",
    sectorId: "steam-roasting",
    sectorName: "Steam Roasting",
    operatorId: "w-9",
    operatorName: "Yaw Owusu",
    supervisorId: "w-2",
    kpiScores: { "kpi-1": 4, "kpi-2": 4, "kpi-3": 3, "kpi-4": 5, "kpi-5": 5 },
    kpiNotes: { "kpi-3": "Minor grading variance." },
    date: "2025-01-26T13:20:00.000Z",
  },
  {
    id: "ev-sample-6",
    sectorId: "shelling",
    sectorName: "Shelling",
    operatorId: "w-10",
    operatorName: "Akua Asare",
    supervisorId: "w-3",
    kpiScores: { "kpi-1": 5, "kpi-2": 5, "kpi-3": 4, "kpi-4": 4, "kpi-5": 4 },
    kpiNotes: {},
    date: "2025-01-25T10:00:00.000Z",
  },
  {
    id: "ev-sample-7",
    sectorId: "peeling",
    sectorName: "Peeling",
    operatorId: "w-11",
    operatorName: "Emmanuel Tetteh",
    supervisorId: "w-4",
    kpiScores: { "kpi-1": 4, "kpi-2": 4, "kpi-3": 4, "kpi-4": 4, "kpi-5": 5 },
    kpiNotes: {},
    date: "2025-01-25T15:30:00.000Z",
  },
  {
    id: "ev-sample-8",
    sectorId: "grading",
    sectorName: "Grading",
    operatorId: "w-12",
    operatorName: "Comfort Ampofo",
    supervisorId: "w-3",
    kpiScores: { "kpi-1": 5, "kpi-2": 5, "kpi-3": 5, "kpi-4": 3, "kpi-5": 4 },
    kpiNotes: { "kpi-4": "Throughput below target on morning shift." },
    date: "2025-01-24T12:00:00.000Z",
  },
];

export function EvaluationsProvider({ children }) {
  const [evaluations, setEvaluations] = useState(sampleEvaluations);

  const addEvaluation = useCallback((ev) => {
    setEvaluations((prev) => [ev, ...prev]);
  }, []);

  const updateEvaluation = useCallback((id, updates) => {
    setEvaluations((prev) =>
      prev.map((e) => (e.id === id ? { ...e, ...updates } : e))
    );
  }, []);

  const removeEvaluation = useCallback((id) => {
    setEvaluations((prev) => prev.filter((e) => e.id !== id));
  }, []);

  const value = { evaluations, addEvaluation, updateEvaluation, removeEvaluation };
  return (
    <EvaluationsContext.Provider value={value}>
      {children}
    </EvaluationsContext.Provider>
  );
}

export function useEvaluations() {
  const ctx = useContext(EvaluationsContext);
  if (!ctx) throw new Error("useEvaluations must be used within EvaluationsProvider");
  return ctx;
}

export default EvaluationsContext;
